
<template>
  <div class="lessonBuy">
    <slot name="lessonBuy">立即报名</slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.lessonBuy {
  background: #74B3FA;
  color: #ffffff;
}
</style>